/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportType } from './reportType';


export interface AccountReportDataApiModel { 
    reportType: ReportType;
    data: string;
}
export namespace AccountReportDataApiModel {
}


